// اماکن
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, qs, toFa, num, Grid, Field, Lookup, MessageBox, Modal, ChangeUsesDialog, SubFormShell, splitLines,
  visibleCols, runReport, smallBtn, DEL_ASK, PP_COLS, HISTORY_COLS,
} from './placeShared';
import PlacePeople from './PlacePeople';
import PropertyPlace2 from './PropertyPlace2';
import PropertyPlaceAllReport from './PropertyPlaceAllReport';

const FORM = 'FRMPLACE';
const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNPLACEPEOPLE', 'BTNPROPERTYPLACE',
  'BTNHISTORY', 'BTNPERMISSIONSLIST', 'BTNEMPLOYEEGOODSREQUEST', 'BTNPROPERTYPLACEREPORT', 'BTNPROPERTYPLACEALLREPORT',
  'BTNPROPERTYPLACESUMMARY', 'BTNCHANGE', 'BTNMOVE'];

const COLS = [
  { key: 'place_no', label: 'کد محل' },
  { key: 'place_name', label: 'عنوان', wrap: true },
  { key: 'city', label: 'شهرستان' },
  { key: 'responsible', label: 'مسئول', wrap: true },
  { key: 'property_count', label: 'اقلام اموالی واگذار شده', num: true },
  { key: 'consume_count', label: 'اقلام مصرفی واگذار شده', num: true },
];
const PEOPLE_COLS = [{ key: 'event_date', label: 'تاریخ' }, { key: 'responsible', label: 'مسئول', wrap: true }];
const PROP_COLS = [
  { key: 'property_no', label: 'شماره اموال' }, { key: 'property_name', label: 'نام', wrap: true },
  { key: 'label_no', label: 'برچسب اموال' }, { key: 'portable', label: 'نوع مال' },
  { key: 'portable_type', label: 'نوع منقول' }, { key: 'country', label: 'کشورسازنده' },
  { key: 'price', label: 'قیمت', money: true }, { key: 'serial_no', label: 'شماره سریال' },
];
const PERM_COLS = [{ key: 'place', label: 'مکان', wrap: true }, { key: 'permission_no', label: 'شماره مجوز' },
  { key: 'event_date', label: 'تاریخ' }, { key: 'count', label: 'تعداد اقلام', num: true }];
const EGR_COLS = [{ key: 'asker', label: 'درخواست کننده', wrap: true }, { key: 'place_name', label: 'عنوان مکان', wrap: true },
  { key: 'commander', label: 'دستور دهنده', wrap: true }, { key: 'goods_name', label: 'نام کالا', wrap: true },
  { key: 'quantity', label: 'تعداد', num: true }];

const EMPTY = { place_no: '', place_name: '', city_id: 0, city: '' };

function filterPP(rows, s) {
  s = String(s || '').trim();
  if (!s) return rows;
  const has = (v, x) => String(v ?? '').includes(x);
  if (/^[0-9۰-۹]+$/.test(s)) {
    const n = num(s);
    return rows.filter(r => num(r.request_no) === n || num(r.permission_no) === n || has(r.asker, s)
      || num(r.label_no) === n || String(r.title) === s);
  }
  return rows.filter(r => has(r.asker, s) || has(r.title, s));
}

export default function Place({ user, onBack, onOpenProperty }) {
  const fb = useFormButtons(FORM, BUTTONS);
  const fbProp = useFormButtons('FRMPROPERTY', []);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [people, setPeople] = useState([]);
  const [pps, setPps] = useState([]);
  const [ppSel, setPpSel] = useState(null);
  const [search2, setSearch2] = useState('');
  const [counts, setCounts] = useState(null);
  const [stockOnly, setStockOnly] = useState(false);
  const [props, setProps] = useState(null);         // اموال موجود (کلیک راست)
  const [panel, setPanel] = useState(null);         // {kind, rows, columns, title}
  const [checked, setChecked] = useState(new Set());
  const [pending, setPending] = useState(0);
  const [rep, setRep] = useState({ cons: true, uncons: true, byPlace: true, byAsker: false });
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [formErr, setFormErr] = useState('');
  const [msg, setMsg] = useState(null);
  const [ask, setAsk] = useState(null);
  const [uses, setUses] = useState(null);
  const [sub, setSub] = useState(null);
  const wantPerm = useRef(null);

  const L = usePagedList((page, o) => API(`/?${qs({ page, search: o.search })}`));
  const showMsg = m => setMsg(splitLines(m));

  const reload = useCallback((keepId) => {
    L.reload({ search }).then(j => {
      if (!j || !j.ok) return;
      const rows = j.data || [];
      setSelected((keepId && rows.find(r => r.id === keepId)) || rows[0] || null);
    });
    API('/pending-requests/').then(j => setPending(j.ok ? j.count : 0));
  }, [L, search]);

  useEffect(() => { if (fb.loaded && fb.open) reload(); }, [fb.loaded, fb.open]);

  const loadChildren = useCallback((pl, ppKeep) => {
    setProps(null);
    if (!pl) { setPeople([]); setPps([]); setPpSel(null); return; }
    API(`/${pl.id}/people/`).then(j => setPeople(j.ok ? j.data : []));
    API(`/${pl.id}/property-places/`).then(j => {
      const rows = j.ok ? j.data : [];
      setPps(rows);
      setPpSel((ppKeep && rows.find(ppKeep)) || rows[0] || null);
    });
  }, []);
  useEffect(() => {
    const w = wantPerm.current;
    wantPerm.current = null;
    loadChildren(selected, w ? (x => String(x.permission_no) === String(w)) : null);
  }, [selected, loadChildren]);

  useEffect(() => {
    if (!ppSel || !String(ppSel.title || '').trim()) { setCounts(null); return; }
    API(`/goods-counts/${ppSel.property_id}/?${qs({ stock: stockOnly ? 1 : 0 })}`).then(j => setCounts(j.ok && j.visible ? j : null));
  }, [ppSel, stockOnly]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew = () => { setForm(EMPTY); setFormErr(''); setModal('new'); };
  const openEdit = () => {
    if (!selected) return;
    setForm({ place_no: selected.place_no, place_name: selected.place_name, city_id: selected.city_id, city: selected.city });
    setFormErr(''); setModal('edit');
  };
  const save = async () => {
    const body = JSON.stringify(form);
    const j = modal === 'new' ? await API('/create/', { method: 'POST', body })
      : await API(`/${selected.id}/update/`, { method: 'PUT', body });
    if (j.ok) { setModal(null); reload(j.id); } else setFormErr(j.msg);
  };

  const doDelete = async () => {
    setAsk(null);
    const j = await API(`/${selected.id}/delete/`, { method: 'DELETE' });
    if (j.ok) { setSelected(null); reload(); } else showMsg(j.msg);
  };
  const askDelete = async () => {
    if (!selected) return;
    const j = await API(`/${selected.id}/delete/?check=1`, { method: 'DELETE' });
    if (!j.ok) { showMsg(j.msg); return; }
    setAsk({ title: 'هشدار', lines: [DEL_ASK], onYes: doDelete });
  };

  const openPanel = async (kind) => {
    setChecked(new Set());
    if (kind === 'history') {
      if (!ppSel) return;
      const j = await API(`/history/${ppSel.property_id}/`);
      if (!j.ok) { showMsg(j.msg); return; }
      setPanel({ kind, title: 'سابقه', rows: j.data, columns: visibleCols(HISTORY_COLS, j.data) });
    } else if (kind === 'perms') {
      const j = await API('/permissions-list/');
      if (!j.ok) { showMsg(j.msg); return; }
      if (j.data.length) setPanel({ kind, title: 'حواله ها', rows: j.data, columns: PERM_COLS });
    } else if (kind === 'egr') {
      const j = await API('/employee-requests/');
      if (!j.ok) { showMsg(j.msg); return; }
      setPanel({ kind, title: 'درخواستهای تحویل کالا', rows: j.data, columns: EGR_COLS });
    } else if (kind === 'summary') {
      const j = await API('/summary/');
      if (!j.ok) { showMsg(j.msg); return; }
      if (j.data.length) setPanel({ kind, title: 'گزارش اکسل نماینده اموال اماکن', rows: j.data, columns: j.columns });
    }
  };

  const panelDouble = (r) => {
    if (panel.kind === 'perms') {
      const pl = L.data.find(x => x.id === r.place_id);
      setPanel(null);
      if (pl) {
        if (selected && pl.id === selected.id) {
          const hit = pps.find(x => String(x.permission_no) === String(r.permission_no));
          if (hit) setPpSel(hit);
        } else {
          wantPerm.current = r.permission_no;
          setSelected(pl);
        }
      }
    } else if (panel.kind === 'egr') {
      applyEgr(new Set([...checked, r.id]));
    }
  };
  const applyEgr = async (ids) => {
    const j = await API('/employee-requests/apply/', { method: 'POST', body: JSON.stringify({ ids: [...ids] }) });
    setPanel(null);
    if (!j.ok) { showMsg(j.msg); return; }
    reload(selected && selected.id);
  };
  const toggleCheck = (k) => setChecked(s => { const n = new Set(s); if (n.has(k)) n.delete(k); else n.add(k); return n; });

  const placeReport = () => {
    if (!selected) return;
    const asker = (ppSel || pps[0] || {}).asker_id || 0;
    runReport('tadarokat.place_property_list', {
      place_id: selected.id, asker_id: asker, cons: rep.cons ? 1 : 0, uncons: rep.uncons ? 1 : 0,
      by_place: rep.byPlace ? 1 : 0, by_asker: rep.byAsker && asker ? 1 : 0,
    }, showMsg);
  };

  const openProps = async (pl) => {
    const j = await API(`/${pl.id}/properties/`);
    if (j.ok && j.data.length) setProps(j.data);
  };

  const openUses = async () => {
    if (!selected) return;
    const j = await API(`/${selected.id}/uses/`);
    if (!j.ok || !j.cnt) { showMsg(j.msg); return; }
    setUses(j);
  };
  const doMove = async (targetId, thisYear) => {
    const j = await API(`/${selected.id}/move/`, { method: 'POST', body: JSON.stringify({ target_id: targetId, this_year: thisYear ? 1 : 0 }) });
    if (!j.ok) { showMsg(j.msg); return; }
    setUses(null);
    setAsk({ title: 'انتخاب کنید', lines: ['تغییر انجام شد', '', '', 'آیا رکورد فعلی حذف شود؟'], onYes: () => { setAsk(null); askDelete(); } });
    reload(selected.id);
  };

  const closeSub = () => { setSub(null); reload(selected && selected.id); };

  const shown = visibleCols(COLS, L.data);
  const ppRows = filterPP(pps, search2);
  const ppShown = visibleCols(PP_COLS, ppRows);
  const has = !!selected;
  const canAct = fb.open;
  const btn = (key, label, onClick, style = smallBtn, need = true) => (fb.can(key) && need
    ? <button onClick={onClick} disabled={!has} style={{ ...style, opacity: has ? 1 : 0.4, cursor: 'pointer' }}>{label}</button> : null);
  const chk = (k, label) => (
    <label style={{ fontSize: '11px' }}><input type="checkbox" checked={rep[k]} onChange={e => setRep(r => ({ ...r, [k]: e.target.checked }))} /> {label}</label>
  );

  const toolbar = canAct ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={openNew} style={{ ...ui.btnNew, cursor: 'pointer' }}>＋ جدید</button>}
        {btn('BTNEDIT', '✎ ویرایش', openEdit, ui.btnEdit)}
        {btn('BTNDELETE', '✕ حذف', askDelete, ui.btnDel)}
      </div>
      {btn('BTNPLACEPEOPLE', 'مسئول محل', () => setSub('people'))}
      {btn('BTNPROPERTYPLACE', 'ورود/خروج اموال', () => setSub('pp'))}
      {btn('BTNHISTORY', 'سابقه', () => openPanel('history'), smallBtn, !!ppSel)}
      {fb.can('BTNPERMISSIONSLIST') && <button onClick={() => openPanel('perms')} style={smallBtn}>حواله ها</button>}
      {fb.can('BTNNEW') && pending > 0 && <button onClick={() => openPanel('egr')} style={smallBtn}>درخواستهای تحویل کالا</button>}
      {fb.can('BTNPROPERTYPLACEREPORT') && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '4px 8px' }}>
          {chk('cons', 'مصرفی')}{chk('uncons', 'غیرمصرفی')}{chk('byPlace', 'محل')}{chk('byAsker', 'درخواست کننده')}
          <button onClick={placeReport} disabled={!has || (!rep.cons && !rep.uncons)} style={smallBtn}>فهرست اموال واگذارشده</button>
        </div>
      )}
      {fb.can('BTNPROPERTYPLACEALLREPORT') && <button onClick={() => setSub('all')} style={smallBtn}>گزارش کلی</button>}
      {fb.can('BTNPROPERTYPLACESUMMARY') && <button onClick={() => openPanel('summary')} style={smallBtn}>گزارش اکسل نماینده اموال اماکن</button>}
      {btn('BTNCHANGE', 'تغییر موارد استفاده', openUses)}
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && reload()}
        style={{ ...ui.searchInput, flex: 1, minWidth: '160px' }} placeholder="جستجو" />
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="مکان" />
      <ExcelButton title="اماکن" columns={shown} rows={L.data} />
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title="اماکن" subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading} unit="مکان">
        {canAct && (
          <div style={ui.splitWrap}>
            <div style={ui.topPane}>
              <Grid columns={shown} rows={L.data} selectedId={selected && selected.id} loading={L.loading}
                onSelect={setSelected} onContext={pl => { setSelected(pl); openProps(pl); }} empty="مکانی یافت نشد" />
            </div>
            <div style={{ ...ui.bottomPane, display: 'flex', gap: '8px', padding: '6px' }}>
              {people.length > 0 && (
                <div style={{ flex: '0 0 260px', overflow: 'auto' }}>
                  <Grid columns={PEOPLE_COLS} rows={people} zebra="#fdf6ec" />
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <input value={search2} onChange={e => setSearch2(e.target.value)} placeholder="جستجو"
                    style={{ ...ui.searchInput, minWidth: '180px' }} />
                  {counts && (
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '12px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '4px 10px', background: '#fff' }}>
                      <b>{toFa(ppSel.title)}</b>
                      <span>ورودی: {toFa(counts.in_qty)}</span><span>خروجی: {toFa(counts.out_qty)}</span><span>موجودی: {toFa(counts.stock)}</span>
                      <label><input type="checkbox" checked={stockOnly} onChange={e => setStockOnly(e.target.checked)} /> تایید شده توسط انبار</label>
                    </div>
                  )}
                </div>
                <div style={{ flex: 1, overflow: 'auto' }}>
                  {pps.length > 0 && <Grid columns={ppShown} rows={ppRows} selectedId={ppSel && ppSel.id} onSelect={setPpSel} zebra="#ffebcd" />}
                </div>
              </div>
            </div>
          </div>
        )}
      </ListPage>

      {props && (
        <Modal title={`اموال موجود در ${selected ? selected.place_name : ''} ${selected ? selected.city : ''}`} width="1000px" onClose={() => setProps(null)}
          footer={<ExcelButton title={`اموال موجود در ${selected ? selected.place_name : ''} ${selected ? selected.city : ''}`} columns={visibleCols(PROP_COLS, props)} rows={props} />}>
          <Grid columns={visibleCols(PROP_COLS, props)} rows={props}
            onDouble={r => { if (r.property_id > 0 && fbProp.open && onOpenProperty) onOpenProperty(r); }} />
        </Modal>
      )}

      {panel && (
        <Modal title={panel.title} width="1100px" onClose={() => setPanel(null)}
          footer={<>
            <ExcelButton title={panel.kind === 'summary' ? panel.title : 'اماکن'} columns={panel.columns} rows={panel.rows} />
            {panel.kind === 'egr' && <button onClick={() => applyEgr(checked)} disabled={!checked.size} style={ui.btnSave}>ثبت</button>}
          </>}>
          <Grid columns={panel.columns} rows={panel.rows} onDouble={panelDouble}
            checked={panel.kind === 'egr' ? checked : null} onCheck={toggleCheck} />
        </Modal>
      )}

      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? 'مکان جدید' : 'ویرایش مکان'} onClose={() => setModal(null)}
          footer={<>
            {fb.can('BTNCANCEL') && <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>}
            {fb.can('BTNOK') && <button onClick={save} style={ui.btnSave}>ثبت</button>}
          </>}>
          {formErr && <div style={ui.errBox}>⚠️ {formErr}</div>}
          <div style={ui.row}>
            <Field label="کد محل" value={form.place_no} onChange={v => F('place_no', v)} />
            <Field label="عنوان" value={form.place_name} onChange={v => F('place_name', v)} flex={2} />
          </div>
          <div style={ui.row}>
            <Lookup label="شهرستان" value={form.city} endpoint="/lookup/cities/"
              onPick={r => setForm(f => ({ ...f, city_id: r.id, city: r.title }))} />
          </div>
        </Modal>
      )}

      {uses && <ChangeUsesDialog info={uses} targetsEndpoint={`/${selected.id}/targets/`}
        notChosenMsg="محل جایگزین انتخاب نشده است" onMove={doMove} onClose={() => setUses(null)} />}
      {ask && <WarningDialog title={ask.title} lines={ask.lines} confirmLabel="بلی" cancelLabel="خیر"
        onConfirm={ask.onYes} onCancel={() => setAsk(null)} tone="danger" />}
      {msg && <MessageBox lines={msg} onClose={() => setMsg(null)} />}

      {sub === 'people' && selected && (
        <SubFormShell><PlacePeople user={user} onBack={closeSub} place={selected} /></SubFormShell>
      )}
      {sub === 'pp' && selected && (
        <SubFormShell><PropertyPlace2 user={user} onBack={closeSub} place={selected} /></SubFormShell>
      )}
      {sub === 'all' && (
        <SubFormShell><PropertyPlaceAllReport user={user} onBack={() => setSub(null)} /></SubFormShell>
      )}
    </>
  );
}
